import Vue from 'vue';
import router from './../../router/index'
import { getUser } from "../../api/user";

const state = {
  authTokens: {
    accessToken: null,
    refreshToken: null
  },
  userObjects: [

  ],
  isObjectManager: false,
  user: null
};

const getters = {
  isUserLogged: state => {
    return state.user;
  },
  haveTokens: state => {
    return state.authTokens.accessToken;
  },
  user: state => {
    return state.user;
  },
  isObjectManager: state => {
    return state.isObjectManager;
  }
};

const actions = {
  async fetchUserInfo({ state, commit }) {
    try{
      const userResponse = await getUser(state.authTokens.accessToken);
      if(userResponse.data){
        commit('setUser', userResponse.data.user);
        commit('setUserObjects',userResponse.data.objects);
        commit('structure/setCurrentStructure', userResponse.data.objects[0], { root: true });
      }
    }catch(e){
      router.push({name: 'Login'});
    }
  }
};

const mutations = {
  setAuthTokens(state, accessToken, refreshToken) {
    state.authTokens.accessToken = accessToken;
    state.authTokens.refreshToken = refreshToken;
  },
  setUser(state, user) {
    state.user = user;

    if(user.objectManager){
      state.isObjectManager = true;
    }
  },
  logout(state){
    state.authTokens.accessToken = null;
    state.authTokens.refreshToken = null;
    state.user = null;
    state.isObjectManager = false;
  },
  setUserObjects(state, objects){
    Vue.set(state, 'userObjects',objects);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
